// The separate charges that make up ONE payment for a multi-service order:
// one line per priced Service Job (Process Service — <person>: $x). Shared by
// the Stripe payment page, the emails and the admin Billing panel so all three
// always show the same breakdown. The lines must add up to the amount due; a
// higher approved total adds an "Adjustment" line, a lower one (a discount
// Stripe cannot show as a negative line) falls back to a single total line.
function chargeLines(targets, totalCents) {
  var total = Math.round(Number(totalCents));
  var priced = (Array.isArray(targets) ? targets : []).filter(function (t) {
    return t && t.amount_cents != null && Number(t.amount_cents) > 0;
  });
  if (priced.length < 2 || !isFinite(total) || total <= 0) return null;
  var lines = priced.map(function (t) {
    return { name: "Process Service — " + (t.subject_name || t.job_label || "service"), amountCents: Math.round(Number(t.amount_cents)) };
  });
  var sum = lines.reduce(function (a, l) { return a + l.amountCents; }, 0);
  if (sum === total) return lines;
  if (total > sum) return lines.concat([{ name: "Adjustment", amountCents: total - sum }]);
  return null;
}
module.exports = { chargeLines: chargeLines };
